import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  loader: {
    color: '#fff',
  },
  icon: {
    fontSize: '1.5rem',
    color: '#fff',
  },
  pointer: {
    cursor: 'pointer',
  },
}));
